import { cn } from "@lib/cn"

import { avatarSolid } from "@/constants/avatarTones"

type Size = "sm" | "md" | "lg"

const sizes: Record<Size, string> = {
  sm: "w-7 h-7 text-xs",
  md: "w-9 h-9 text-sm",
  lg: "w-14 h-14 text-lg",
}

function deriveInitials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

export function Avatar({
  name,
  color = "blue",
  size = "md",
  initials,
  className,
}: {
  name: string
  color?: string
  size?: Size
  /** Override the derived initials (e.g. professor's explicit initials). */
  initials?: string
  className?: string
}) {
  return (
    <div
      className={cn(
        "flex flex-shrink-0 items-center justify-center rounded-full font-bold text-white",
        avatarSolid(color),
        sizes[size],
        className,
      )}
    >
      {initials ?? deriveInitials(name)}
    </div>
  )
}
